import ReviewAdvancedView from './ReviewAdvancedView'

export default ReviewAdvancedView
